import { Directive, TemplateRef } from '@angular/core';

@Directive({
  selector: '[body-template]',
  standalone: false,
})
export class BodyTemplateDirective {
  constructor(public template: TemplateRef<any>) {}
}
